import React from 'react';
import theme from './ChangeRequestMergeWizardStepSelection.module.scss';
import { SelectionList } from '@ygtechnologies/rubus-ui';
import { ChangeRequest } from '@/types';
import { toggleValue } from '@ygtechnologies/rubus-frontend-utilities';
import Tags from '@/components/Tags';

interface ChangeRequestMergeWizardStepSelectionProps {
    changeRequests: ChangeRequest[];
    value: ChangeRequest[];
    onChange(selection: ChangeRequest[]): void;
}

const ChangeRequestMergeWizardStepSelection: React.FC<ChangeRequestMergeWizardStepSelectionProps> = ({
    changeRequests,
    value,
    onChange,
}) => {
    return (
        <SelectionList>
            {changeRequests.map((cr) => (
                <SelectionList.Item
                    key={cr.id}
                    selected={value.includes(cr)}
                    onChange={(checked) => onChange(toggleValue(value, cr, checked))}
                    label={
                        <div>
                            <span className={theme.requestNumber}>#{cr.id}</span>
                            <span>{cr.subject}</span>
                        </div>
                    }
                    meta={<Tags tags={cr.tags} size="small" />}
                />
            ))}
        </SelectionList>
    );
};

export default ChangeRequestMergeWizardStepSelection;
